var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "b-row",
        { staticClass: "header align-items-center" },
        [
          _c(
            "b-col",
            { staticClass: "font-italic text-right", attrs: { cols: "12" } },
            [
              _vm.saving
                ? _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.saving")) + "..."),
                  ])
                : _vm.referrer
                ? _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.actions.lastSaved")) +
                        ":\n        " +
                        _vm._s(
                          _vm._f("formatTimeAgo")(_vm.referrer.updatedAt)
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "order-1 vertical-center mb-2" },
            [
              _c("back-button", { attrs: { "static-route": "referrers" } }),
              _vm._v(" "),
              _c(
                "h2",
                {
                  staticClass:
                    "header-title mb-0 d-flex align-items-center justify-content-start",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.referrer.givenName || "") +
                      " " +
                      _vm._s(_vm.referrer.familyName || "") +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "vertical-center col-auto order-2 order-xl-3" },
            [
              _c(
                "simple-button",
                { attrs: { type: "white", "class-name": "btn-sm p-0" } },
                [
                  _c(
                    "b-dropdown",
                    {
                      ref: "actionsDropdown",
                      attrs: {
                        variant: "white",
                        "toggle-class": "btn-sm shadow-none b-0",
                        "menu-class": "overflow-visible",
                        right: "",
                      },
                      on: { hide: _vm.hideDropdown },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "d-lg-inline d-none" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("global.words.actions")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "i",
                                { staticClass: "material-icons d-lg-none" },
                                [_vm._v("more_vert")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "inline-prompt",
                        {
                          staticClass: "clickable",
                          attrs: {
                            "action-type": "delete",
                            placement: "left",
                            "confirmation-text":
                              "i18n|global.actions.confirmDelete",
                            loading: _vm.loading,
                          },
                          on: {
                            accept: _vm.handleDeleteReferrer,
                            dismiss: _vm.inlinePromptHide,
                            prompt: _vm.inlinePromptShown,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-danger text-darken-3 pr-0 mt-2 d-block text-center",
                              attrs: {
                                id: "trigger-delete-referrer",
                                tabindex: "0",
                                role: "menuitem",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("referrers.actions.deleteReferrer")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }